import React from 'react';
import { ReactComponent as BBVAIcon } from '../../../../assets/paymentMethods/bank/bbva.svg';
import { ReactComponent as AstropayIcon } from '../../../../assets/paymentMethods/bank/astropay.svg';
import { ReactComponent as BancoCoinagIcon } from '../../../../assets/paymentMethods/bank/banco-coinag.svg';
import { ReactComponent as BancoColumbiaIcon } from '../../../../assets/paymentMethods/bank/banco-columbia.svg';
import { ReactComponent as BancoComafiIcon } from '../../../../assets/paymentMethods/bank/banco-comafi.svg';
import { ReactComponent as BancoCorrientesIcon } from '../../../../assets/paymentMethods/bank/banco-corrientes.svg';
import { ReactComponent as BancoCredicoopIcon } from '../../../../assets/paymentMethods/bank/banco-credicoop.svg';
import { ReactComponent as BancoDelSolIcon } from '../../../../assets/paymentMethods/bank/banco-del-sol.svg';
import { ReactComponent as BancoEntreRiosIcon } from '../../../../assets/paymentMethods/bank/banco-entre-rios.svg';
import { ReactComponent as BancoHipotecarioIcon } from '../../../../assets/paymentMethods/bank/banco-hipotecario.svg';
import { ReactComponent as BancoHsbcIcon } from '../../../../assets/paymentMethods/bank/banco-hsbc.svg';
import { ReactComponent as BancoIcbcIcon } from '../../../../assets/paymentMethods/bank/banco-icbc.svg';
import { ReactComponent as BancoItauIcon } from '../../../../assets/paymentMethods/bank/banco-itau.svg';
import { ReactComponent as BancoMacroIcon } from '../../../../assets/paymentMethods/bank/banco-macro.svg';
import { ReactComponent as BancoMunicipalIcon } from '../../../../assets/paymentMethods/bank/banco-municipal.svg';
import { ReactComponent as BancoNacionIcon } from '../../../../assets/paymentMethods/bank/banco-nacion.svg';
import { ReactComponent as BancoPatagoniaIcon } from '../../../../assets/paymentMethods/bank/banco-patagonia.svg';
import { ReactComponent as BancoPianoIcon } from '../../../../assets/paymentMethods/bank/banco-piano.svg';
import { ReactComponent as BancoProvinciaIcon } from '../../../../assets/paymentMethods/bank/banco-provincia.svg';
import { ReactComponent as BancoSanJuanIcon } from '../../../../assets/paymentMethods/bank/banco-san-juan.svg';
import { ReactComponent as BancoSantaCruzIcon } from '../../../../assets/paymentMethods/bank/banco-santa-cruz.svg';
import { ReactComponent as BancoSantaFeIcon } from '../../../../assets/paymentMethods/bank/banco-santa-fe.svg';
import { ReactComponent as BancoSantanderIcon } from '../../../../assets/paymentMethods/bank/banco-santander.svg';
import { ReactComponent as BancoSupervielleIcon } from '../../../../assets/paymentMethods/bank/banco-supervielle.svg';
import { ReactComponent as BancorIcon } from '../../../../assets/paymentMethods/bank/bancor.svg';
import { ReactComponent as BeloIcon } from '../../../../assets/paymentMethods/bank/belo.svg';
import { ReactComponent as BerryIcon } from '../../../../assets/paymentMethods/bank/BERRY.svg';
import { ReactComponent as BicaIcon } from '../../../../assets/paymentMethods/bank/bica.svg';
import { ReactComponent as BpnIcon } from '../../../../assets/paymentMethods/bank/bpn.svg';
import { ReactComponent as BrubankIcon } from '../../../../assets/paymentMethods/bank/brubank.svg';
import { ReactComponent as BuenbitIcon } from '../../../../assets/paymentMethods/bank/buenbit.svg';
import { ReactComponent as CabalIcon } from '../../../../assets/paymentMethods/bank/cabal.svg';
import { ReactComponent as CencopayIcon } from '../../../../assets/paymentMethods/bank/cencopay.svg';
import { ReactComponent as CiudadIcon } from '../../../../assets/paymentMethods/bank/ciudad.svg';
import { ReactComponent as ClaroPayIcon } from '../../../../assets/paymentMethods/bank/claro-pay.svg';
import { ReactComponent as CocosIcon } from '../../../../assets/paymentMethods/bank/cocos.svg';
import { ReactComponent as CocosCryptoIcon } from '../../../../assets/paymentMethods/bank/cocos-crypto.svg';
import { ReactComponent as CuentaDniIcon } from '../../../../assets/paymentMethods/bank/cuenta-dni.svg';
import { ReactComponent as DolarAppIcon } from '../../../../assets/paymentMethods/bank/dolar-app.svg';
import { ReactComponent as FiwindIcon } from '../../../../assets/paymentMethods/bank/fiwind.svg';
import { ReactComponent as GaliciaIcon } from '../../../../assets/paymentMethods/bank/galicia.svg';
import { ReactComponent as LemonIcon } from '../../../../assets/paymentMethods/bank/lemon.svg';
import { ReactComponent as LetsbitIcon } from '../../../../assets/paymentMethods/bank/letsbit.svg';
import { ReactComponent as NaranjaXIcon } from '../../../../assets/paymentMethods/bank/naranja-x.svg';
import { ReactComponent as OpenbankIcon } from '../../../../assets/paymentMethods/bank/openbank.svg';
import { ReactComponent as PersonalPayIcon } from '../../../../assets/paymentMethods/bank/personal-pay.svg';
import { ReactComponent as PlusCryptoIcon } from '../../../../assets/paymentMethods/bank/plus-crypto.svg';
import { ReactComponent as PrexIcon } from '../../../../assets/paymentMethods/bank/prex.svg';
import { ReactComponent as RipioIcon } from '../../../../assets/paymentMethods/bank/ripio.svg';
import { ReactComponent as SatoshiTangoIcon } from '../../../../assets/paymentMethods/bank/satoshi-tango.svg';
import { ReactComponent as TakenosIcon } from '../../../../assets/paymentMethods/bank/takenos.svg';
import { ReactComponent as UalaIcon } from '../../../../assets/paymentMethods/bank/uala.svg';
import { ReactComponent as WallbitIcon } from '../../../../assets/paymentMethods/bank/wallbit.svg';
import { ReactComponent as YoyIcon } from '../../../../assets/paymentMethods/bank/yoy.svg';
import { ReactComponent as CardIcon } from '../../../../assets/paymentMethods/card.svg';
import { ReactComponent as ModoIcon } from '../../../../assets/paymentMethods/modo.svg';

const CardBankIcon = ({ bank, modoTag }) => {
  // Mapping from server enum values to icon components
  const bankIconMap = {
    ASTROPAY: AstropayIcon,
    BANCO_COINAG: BancoCoinagIcon,
    BANCO_COLUMBIA: BancoColumbiaIcon,
    BANCO_COMAFI: BancoComafiIcon,
    BANCO_CORRIENTES: BancoCorrientesIcon,
    BANCO_CREDICOOP: BancoCredicoopIcon,
    BANCO_DEL_SOL: BancoDelSolIcon,
    BANCO_ENTRE_RIOS: BancoEntreRiosIcon,
    BANCO_HIPOTECARIO: BancoHipotecarioIcon,
    BANCO_HSBC: BancoHsbcIcon,
    BANCO_ICBC: BancoIcbcIcon,
    BANCO_ITAU: BancoItauIcon,
    BANCO_MACRO: BancoMacroIcon,
    BANCO_MUNICIPAL: BancoMunicipalIcon,
    BANCO_NACION: BancoNacionIcon,
    BANCO_PATAGONIA: BancoPatagoniaIcon,
    BANCO_PIANO: BancoPianoIcon,
    BANCO_PROVINCIA: BancoProvinciaIcon,
    BANCO_SAN_JUAN: BancoSanJuanIcon,
    BANCO_SANTA_CRUZ: BancoSantaCruzIcon,
    BANCO_SANTA_FE: BancoSantaFeIcon,
    BANCO_SANTANDER: BancoSantanderIcon,
    BANCO_SUPERVIELLE: BancoSupervielleIcon,
    BBVA: BBVAIcon,
    BANCOR: BancorIcon,
    BELO: BeloIcon,
    BERRY: BerryIcon,
    BICA: BicaIcon,
    BPN: BpnIcon,
    BRUBANK: BrubankIcon,
    BUENBIT: BuenbitIcon,
    CABAL: CabalIcon,
    CENCOPAY: CencopayIcon,
    CIUDAD: CiudadIcon,
    CLARO_PAY: ClaroPayIcon,
    COCOS: CocosIcon,
    COCOS_CRYPTO: CocosCryptoIcon,
    CUENTA_DNI: CuentaDniIcon,
    DOLAR_APP: DolarAppIcon,
    FIWIND: FiwindIcon,
    GALICIA: GaliciaIcon,
    LEMON: LemonIcon,
    LETSBIT: LetsbitIcon,
    NARANJA_X: NaranjaXIcon,
    OPENBANK: OpenbankIcon,
    PERSONAL_PAY: PersonalPayIcon,
    PLUS_CRYPTO: PlusCryptoIcon,
    PREX: PrexIcon,
    RIPIO: RipioIcon,
    SATOSHI_TANGO: SatoshiTangoIcon,
    TAKENOS: TakenosIcon,
    UALA: UalaIcon,
    WALLBIT: WallbitIcon,
    YOY: YoyIcon,
  };

  const IconComponent = bankIconMap[bank];

  if (!IconComponent) {
    return <CardIcon className="mainIcon" />;
  }

  return (
    <div className="mainIconContainer">
      <IconComponent className="mainIcon" />
      {modoTag && <ModoIcon className="modoTag" />}
    </div>
  );
};

export default CardBankIcon;
